export const DAY_MS = 24 * 60 * 60 * 1000;

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

/** Turns anything the API may return into a Date, or null when it is not a usable date. */
export function parseDateOrNull(value: unknown): Date | null {
  if (!value) return null;

  const parsed = value instanceof Date ? value : new Date(String(value));

  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** The latest of the given dates, or null when none of them is usable. */
export function getMostRecentDate(...values: Array<Date | string | null | undefined>): Date | null {
  const candidates = values
    .map(value => parseDateOrNull(value))
    .filter((value): value is Date => value !== null);

  if (candidates.length === 0) return null;

  return candidates.reduce((latest, candidate) =>
    candidate.getTime() > latest.getTime() ? candidate : latest,
  );
}

/** Local date and time, matching the format of {@link useFormattedDate}. */
export function formatDateTime(date: Date, language: string): string {
  return date.toLocaleString(language, DATE_TIME_OPTIONS);
}

/** A day without a time of day, in the user's language. */
export function formatDate(date: Date, language: string): string {
  return date.toLocaleDateString(language, { day: "2-digit", month: "2-digit", year: "numeric" });
}

/** Tachograph deadlines are legally defined in UTC, so they are shown as such. */
export function formatUtcDateTime(date: Date): string {
  return `${date.toISOString().slice(0, 16).replace("T", " ")} UTC`;
}

export function formatUtcDate(date: Date): string {
  return date.toISOString().slice(0, 10).replace(/-/g, "/");
}
